import axios from 'axios';


const instance = axios.create({
    baseURL: 'https://tinder-clone-2020.herokuapp.com/'
})

export default instance;